<template>
    <v-dialog v-model="show" persistent width="500px">
        <v-wait for="loading campaign units">
            <template slot="waiting">
                <v-card>
                    <v-toolbar dark color="primary"></v-toolbar>
                    <vcl-list height="200"></vcl-list>
                </v-card>
            </template>
            <v-card v-if="campaignUnit">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        Campaign action for
                        <router-link
                            class="accent--text text--lighten-1"
                            :to="{name:'unit', params: { unitId: campaignUnit.unitId }}"
                        >{{campaignUnit.unitNumber}}</router-link>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" icon text>
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-layout wrap class="mx-4">
                    <v-flex
                        class="pt-3 subtitle-1"
                        xs12
                    >{{campaignUnit.campaignNumber}}: {{campaignUnit.campaignName}}</v-flex>
                    <v-flex class="pb-3 subtitle-2" xs12>{{campaignUnit.campaignTsbWpaReference}}</v-flex>
                    <v-flex xs12>
                        <date
                            v-model="model.completedDate"
                            v-validate="'required'"
                            required
                            name="completed date"
                            :error-messages="errors.first('completed date')"
                            :max="today"
                            :min="mindate"
                        >
                            <template v-slot:prepend>Completed&nbsp;on</template>
                        </date>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                            v-model="model.completedBy"
                            placeholder="by who? (e.g. 060 - Kris Shepherd)"
                            v-validate="'required'"
                            name="completed by"
                            :error-messages="errors.first('completed by')"
                            required
                            maxlength="150"
                        >
                            <template v-slot:prepend>Completed&nbsp;by</template>
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="close">Cancel</v-btn>
                    <v-btn color="primary" :disabled="disableSubmit" @click="submit">Complete</v-btn>
                </v-card-actions>
            </v-card>
        </v-wait>
    </v-dialog>
</template>
<script>
import { Event } from '@/plugins/bus';
import CampaignsClient from '@/components/Campaigns/CampaignClient.vue';
import { VclList } from 'vue-content-loading';
import { IntervalType } from '@/models/enums';
import moment from 'moment';
import Decimal from '@/components/Decimal.vue';
import Date from '@/components/Date.vue';
import { DateFormat } from '@/plugins/date-filter';
import { Validator } from 'vee-validate';

export default {
    mixins: [CampaignsClient],
    components: {
        VclList,
        Decimal,
        Date
    },
    data() {
        return {
            campaignUnit: null,
            show: null,
            model: {},
            today: moment({ hour: 23, minute: 59, seconds: 59, milliseconds: 999 }).format(DateFormat.Canonical),
            mindate: null
        };
    },
    computed: {
        campaignUnitId() {
            return this.$route.query && this.$route.query.campaignUnitId;
        },
        disableSubmit() {
            return Object.keys(this.fields).some(key => this.fields[key].validated && this.fields[key].invalid);
        }
    },
    methods: {
        submit(event) {
            this.$validator.validate().then(this.complete);
        },
        reValidate(formInput, modelField) {
            this.$validator.validate(formInput, modelField);
        },
        async complete(valid) {
            if (!valid) {
                return;
            }
            await this.completeCampaignUnit(this.model.id, this.model);
        },
        close() {
            var isClear = !this.campaignUnit;
            this.campaignUnit = null;

            if (!isClear) {
                this.$router.back();
            }
        },
        resetModel() {
            if (!this.campaignUnit) {
                return;
            }
            this.model = {
                id: this.campaignUnitId,
                completedBy: '',
                completedDate: this.today
            };
            this.mindate = moment(this.campaignUnit.campaignCreatedOn).format(DateFormat.Canonical);
        }
    },
    watch: {
        async show(val) {
            if (val) {
                this.campaignUnit = (await this.getCampaignUnits(`?id=${this.campaignUnitId}`))[0];
                this.resetModel();
            }
        },
        $route: {
            handler(val) {
                this.show = !!this.campaignUnitId;
            },
            deep: true
        }
    },
    async mounted() {
        this.show = !!this.campaignUnitId;
        this.$bus.$on(Event.CampaignCompleted, this.close);

        if (this.show) {
            this.campaignUnit = await this.getCampaignUnits(`?id=${this.campaignUnitId}`);
            this.resetModel();
        }
    },
    destroyed() {
        this.$bus.$off(Event.CampaignCompleted, this.close);
    }
};
</script>
<style>
.completed-date-input .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}
</style>
